import React, {useState, useEffect, useCallback, useRef} from "react";
import {motion, AnimatePresence} from "framer-motion";
import {TestimonialsProps} from "../types/types";

const TestimonialSectionBlk = ({testimonials}: TestimonialsProps) => {
  const [index, setIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const handleNext = useCallback(() => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  }, [testimonials.length]);

  const handlePrev = useCallback(() => {
    setIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  }, [testimonials.length]);

  const goToSlide = (slideIndex: number) => {
    setIndex(slideIndex);
    resetInterval();
  };

  const resetInterval = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(handleNext, 6000); // auto-slide every 6 sec
  }, [handleNext]);

  useEffect(() => {
    resetInterval();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [resetInterval]);

  return (
    <div className="main-container-blk">
      <div className="client-testimonials-blk">
        <h2>Client Testimonials</h2>

        <div className="testimonial-content-blk relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{opacity: 0, y: 40}}
              animate={{opacity: 1, y: 0}}
              exit={{opacity: 0, y: -40}}
              transition={{duration: 0.4}}>
              <p>“{testimonials[index].quote}”</p>
              <div className="flexbox-testimonials-footnote-blk">
                <div>
                  <img src={testimonials[index].image} />
                </div>
                <div>
                  <h2>{testimonials[index].author}</h2>

                  <p>{testimonials[index].role}</p>
                  {testimonials[index].company && (
                    <p>{testimonials[index].company}</p>
                  )}

                  {testimonials[index].link && (
                    <a href={testimonials[index].link}></a>
                  )}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="pagination-testimonials-blk">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => goToSlide(i)}
                className={`pagination-circle-blk ${
                  i === index ? "active" : "not-active"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSectionBlk;
